import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable, Subject, concat, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap, catchError, filter } from 'rxjs/operators';
import axios from 'axios';

@Component({
    selector: 'app-work-offer-lookup',
    templateUrl: './work-offer-lookup.component.html',
    styleUrls: ['./work-offer-lookup.component.css']
})
export class WorkOfferLookupComponent implements OnInit {
    searchInput = new Subject<string>();
    workOfferLists: any[] = [];
    @Input() set resetData(isClear) {
        this.workOfferLoading = false;
        this.workOffersSelected = this.isMultipleSelected ? [] : null;
    }
    @Output() getWorkOfferObj: EventEmitter<any> = new EventEmitter;
    @Input() isMultipleSelected = true;
    workOffersSelected: any;
    workOfferLoading = false;

    constructor(
    ) {
    }

    ngOnInit() {
        const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
        if (preselected && preselected['workOfferLabel'] && preselected['workOfferLabel'].length) {
            this.workOffersSelected = preselected['workOfferLabel'];
            this.onWorkOfferChange();
            this.searchItems('', this.workOffersSelected).subscribe(results => {
                console.log('Preselected Work Offer Search Results:', results);
                this.workOfferLists = results;
            });
        } else {
            this.workOfferLists = [];
        }
        
        this.searchInput.pipe(
            debounceTime(300), // Wait for 300ms after each keystroke before considering the term
            distinctUntilChanged(), // Only emit if the term has changed
            filter(term => term && term.length > 2), // Only trigger if more than 2 characters
            tap(() => (this.workOfferLoading = true)), // Set loading flag
            switchMap(term =>
                this.searchItems(term).pipe(
                    catchError(() => of([])), // Return empty array on error
                    tap(() => (this.workOfferLoading = false)) // Clear loading flag
                )
            )
        ).subscribe(results => {
            console.log('Work Offer Search Results:', results);
            this.workOfferLists = results;
        });
    }

    private searchItems(term: string, sfdcId?: any): Observable<any[]> {
        let reqObj = {
            name: term,
            sfdcId: sfdcId
        };

        // Replace with your actual API endpoint and data structure
        const apiURL = `https://api.serviceo.me/phoenix/api/work-offers/search`;
        return new Observable<any[]>(observer => {
            axios.post(apiURL, reqObj)
                .then(response => {
                    console.log('Work Offer Search Response:', response.data);
                    observer.next(response.data.data); // Assuming the API returns an array of work offers in response.data.data
                    observer.complete();
                })
                .catch(() => {
                    observer.next([]);
                    observer.complete();
                });
        });
    }

    onWorkOfferChange() {
        this.getWorkOfferObj.emit(this.workOffersSelected);
    }

    clearWorkOffer() {
        this.workOffersSelected = this.isMultipleSelected ? [] : null;
        this.getWorkOfferObj.emit([]);
    }
}

